import { Box, styled, Theme } from '@mui/material';
import { GRID_CONTAINER_BORDER_WIDTH } from 'src/constants';

const sectionBorderWidth = 2;
const screenBorderWidth = 24;
const editorScreenBorderWidth = 10;

const getBorderWidth = (type: 'screen' | 'section' | 'editor' | 'grid') => {
  return type === 'screen'
    ? screenBorderWidth
    : type === 'editor'
    ? editorScreenBorderWidth
    : type === 'grid'
    ? GRID_CONTAINER_BORDER_WIDTH
    : sectionBorderWidth;
};

const getBorderColor = (
  type: 'screen' | 'section' | 'editor' | 'grid',
  editable: boolean,
  isSelected: boolean,
  isHovered: boolean,
  theme: Theme,
) => {
  if (isSelected || (isHovered && editable)) {
    return theme.palette.primary.dark;
  }

  return type === 'screen'
    ? theme.palette.secondary.dark
    : type === 'editor'
    ? theme.palette.secondary.dark
    : type === 'grid'
    ? theme.palette.secondary.dark
    : theme.palette.primary.light;
};

export const FullSizeAssemblyScreenContainer = styled(Box)(
  ({ theme, height, width, $selectable, $type, $isSelected }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  position: relative;
  box-sizing: content-box;
  width: ${width}px;
  height: ${height}px;
  
  cursor: ${$selectable ? 'pointer' : 'unset'};
  border: ${getBorderWidth($type)}px solid ${getBorderColor(
    $type,
    $selectable,
    $isSelected,
    false,
    theme,
  )};
  background-color: ${theme.palette.primary.lighter};

  &:hover {
    border: ${getBorderWidth($type)}px solid ${getBorderColor(
    $type,
    $selectable,
    $isSelected,
    true,
    theme,
  )};
  }
`,
);

export const FullSizeAssemblyScreenEditIconContainer = styled(Box)(
  ({ theme }) => `
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  svg {
    height: 100%;
    width: 50%;

    fill: ${theme.palette.primary.lighter};
  }
`,
);
